<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext } from "svelte";
	import { max } from "d3-array";
	import { draw, fade } from "svelte/transition";
	import { quintOut } from "svelte/easing";

	const { data, x, y, xScale, yGet, xRange, yRange, z, zGet } = getContext("LayerCake");

	// export let label = (d) => $z(d);
	// const formatValue = (value) => `${value} Demos`;
	export let formatDate = (value) => `August ${new Date(value).getFullYear()}`;
	export let labelPosition;
	export let lineDrawDuration;
	export let dataValue;

	/* --------------------------------------------
	 * Put the label on the highest value
	 */
	$: left = (values) => $xScale(max(values, $x)) / Math.max(...$xRange);
	$: top = (values) => {
		return $yGet(values[values.length - 1]) / Math.max(...$yRange);
		// return raw < 0.2 ? 0.2 : raw;
	};
</script>

{#each $data as group (group.id || group.topic)}
	{#if !group.settings.faded && !group.settings.hideFinalValueLabel}
		<div
			in:fade={{ duration: 300, delay: lineDrawDuration, ease: quintOut }}
			class="label"
			class:right={labelPosition === "right"}
			style="
					top:{top(group.values) * 100}%;
					left:{left(group.values) * 100}%;
			"
		>
			<span class="label__main" style="color:{$zGet(group)}"
				>{`${$y(group.values[group.values.length - 1])} ${dataValue === "count" ? "Demos" : "Teilnehmende"}`}</span
			>
			<span class="label__secondary" style="color:{$zGet(group)}">{formatDate(max(group.values, $x))}</span>
		</div>
	{/if}
{/each}

<style lang="scss">
	.label {
		position: absolute;
		// transform: translate(0, -100%) translateY(1px);
		color: #fff;
		font-family: Franklin Gothic FS;

		// max-width: 30px;
		transform: translate(-50%, 20%) translateY(1px);

		@media (max-width: $breakpoint-mobile-l) {
			transform: translate(-50%, 20%) translateY(-4px);
		}


		span {
			white-space: nowrap;
			display: block;
			font-size: 11px;
			font-style: normal;
			line-height: 120%;
			text-align: center;
			text-shadow: -1px -1px 0 #211c46, 1px -1px 0 #211c46, -1px 1px 0 #211c46, 1px 1px 0 #211c46;

			// @media (max-width: $breakpoint-mobile) {
			// 	white-space: normal;
			// }
		}

		&__main {
			font-weight: $medium;
		}

		&__secondary {
			opacity: 0.65;
		}
	}
</style>
